import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass(`shadowContent w100 posRe scheduleContent rad10 mb20`),
  style: {"height":"200px"}
}
const _hoisted_3 = { class: "w100" }
const _hoisted_4 = {
  key: 0,
  class: "fl mr10"
}
const _hoisted_5 = {
  key: 1,
  class: "fl mr10"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", {
  class: "fl label label-green",
  style: {"font-size":"13px"}
}, "確定した日程", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 2,
  class: "fl mr10"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", {
  class: "fl label circle_button alertRedAround rad6",
  style: {"font-size":"13px"}
}, "キャンセル済み", -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 3,
  class: "fl mr10"
}
const _hoisted_12 = { class: "fl mr10 mt2" }
const _hoisted_13 = { class: "fl fs12" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_15 = { class: "fs16 appointmentTitle fw600" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "fs16" }, "■", -1)
const _hoisted_17 = {
  style: {"line-height":"24px"},
  class: "fs11 appointmentInfo"
}
const _hoisted_18 = {
  key: 0,
  class: "fs16 arial fw600"
}
const _hoisted_19 = { class: "fs13" }
const _hoisted_20 = {
  key: 1,
  class: "fs16 arial fw600"
}
const _hoisted_21 = { class: "fs13" }
const _hoisted_22 = { key: 2 }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = { key: 3 }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_27 = { class: "appoLocationImage ofh fr" }
const _hoisted_28 = {
  key: 0,
  class: "fs12 skyblue fl"
}
const _hoisted_29 = ["href"]
const _hoisted_30 = ["src"]
const _hoisted_31 = { key: 1 }
const _hoisted_32 = ["href"]
const _hoisted_33 = ["src"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tooltip = _resolveComponent("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.appo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "fl pad10 appoCardView ofs",
            style: _normalizeStyle({
                    width: `calc( 100% - 200px )`,
                    height: `200px`,
                })
          }, [
            _createElementVNode("div", _hoisted_3, [
              (_ctx.appoindex == 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_4, "調整中の予定"))
                : _createCommentVNode("", true),
              (_ctx.appo.status == 10)
                ? (_openBlock(), _createElementBlock("p", _hoisted_5, _hoisted_7))
                : (_ctx.appo.status == -1)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_8, _hoisted_10))
                  : (_openBlock(), _createElementBlock("p", _hoisted_11, " ")),
              _createElementVNode("p", _hoisted_12, [
                _createElementVNode("span", _hoisted_13, "作成日: " + _toDisplayString(_ctx.createdAtText()), 1)
              ]),
              _createVNode(_component_tooltip, {
                text: "コピーしました!",
                trigger: "manual",
                modelValue: _ctx.showTip,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showTip) = $event))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("p", {
                    class: "circle_button fs10 fr dgrey",
                    style: {"padding":"2px 14px"},
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copyScheduleInfo && _ctx.copyScheduleInfo(...args)))
                  }, " クリップボードにコピー ")
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _hoisted_14,
            _createElementVNode("p", _hoisted_15, [
              _hoisted_16,
              _createTextVNode("   " + _toDisplayString(_ctx.appo ? _ctx.appo.name : ""), 1)
            ]),
            _createElementVNode("p", _hoisted_17, [
              (_ctx.appo.status == 10)
                ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                    _createTextVNode(_toDisplayString(_ctx.fixedTimeFormat()) + "   ", 1),
                    _createElementVNode("span", _hoisted_19, "時間: " + _toDisplayString(_ctx.appo.duration ? `${_ctx.appo.duration}分` : `60分`), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.appo.status == -1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                    _createElementVNode("del", null, [
                      _createTextVNode(_toDisplayString(_ctx.fixedTimeFormat()) + "   ", 1),
                      _createElementVNode("span", _hoisted_21, "時間: " + _toDisplayString(_ctx.appo.duration ? `${_ctx.appo.duration}分` : `60分`), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.appo.status == 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_22, "時間: " + _toDisplayString(_ctx.appo.duration ? `${_ctx.appo.duration}分` : `60分`), 1))
                : _createCommentVNode("", true),
              _hoisted_23,
              _createTextVNode(" 場所: " + _toDisplayString(_ctx.appo.location_name ? `${_ctx.appo.location_name}` : ``) + " ", 1),
              _hoisted_24,
              (_ctx.appo.memo)
                ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                    _createTextVNode(" メモ: " + _toDisplayString(_ctx.appo.memo ? `${_ctx.appo.memo}` : ``) + " ", 1),
                    _hoisted_26
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 4),
          _createElementVNode("div", _hoisted_27, [
            (_ctx.Util.isUrl(_ctx.appo.location_name))
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _createElementVNode("a", {
                    href: _ctx.locationHref(),
                    target: "_blank",
                    style: {"height":"198px","width":"200px"}
                  }, [
                    _createElementVNode("img", {
                      src: _ctx.$getAssetImageUrl(_ctx.Util.getURLFromAddress(`${_ctx.appo.location_name}`, `320x320`, true)),
                      height: "198",
                      width: "200"
                    }, null, 8, _hoisted_30)
                  ], 8, _hoisted_29)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  _createElementVNode("a", {
                    href: _ctx.locationHref(),
                    target: "_blank",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goGmap && _ctx.goGmap(...args))),
                    style: {"height":"198px","width":"200px"}
                  }, [
                    _createElementVNode("img", {
                      src: 
                                _ctx.$getAssetImageUrl(
                                    _ctx.Util.getURLFromAddress(
                                        `${_ctx.appo.selected_location?.address || _ctx.appo.location_name}`,
                                        `320x320`,
                                        true
                                    )
                                )
                            ,
                      style: {"height":"198px"}
                    }, null, 8, _hoisted_33)
                  ], 8, _hoisted_32)
                ]))
          ]),
          _hoisted_34
        ]))
      : _createCommentVNode("", true),
    _hoisted_35
  ]))
}